import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { defineDirective } from '~/scripts/utils/alpine'

/**
 * x-reveal directive
 * @example Reveal an element when it's in the viewport
 * <div x-reveal></div>
 */
export default defineDirective((element, attribute) => {
  const percent = attribute.value || '80'

  console.log(percent)
  ScrollTrigger.create({
    trigger: element,
    start: 'top ' + percent + '%',
    once: true,
    onEnter: () => {
      element.classList.add('revealed')
    },
  })
})
